const routes = [
  {
    path: "/", // the url
    icon: "MdHomeFilled", // the component being exported from icons/index.js
    name: "داشبورد", // name that appear in Sidebar
  },
  {
    icon: "MdCloudUpload",
    name: "آپلود فایل",
    routes: [
      // submenu
      {
        path: "/Upload",
        name: "آپلود فایل جدید",
      },
      {
        path: "/history",
        name: "گزارش فایل های پیشین",
      },
    ],
  },
  {
    icon: "MdGroup",
    name: "درخواست سهامداران",
    routes: [
      {
        path: "/personal",
        name: "بررسی اطلاعات فردی",
      },
      {
        path: "/bank",
        name: "تغییر اطلاعات بانکی",
      },
      {
        path: "/address",
        name: "تغییر اطلاعات آدرس",
      },
      {
        path: "/stockrequests",
        name: "درخواست افزودن سهامدار",
      },
      {
        path: "/lawyerrequests",
        name: "درخواست نماینده",
      },
      {
        path: "/contradiction/0",
        name: "لیست مغایرت ها",
      },
    ],
  },
  {
    icon: "MdEmojiPeople",
    name: "حق تقدم",
    routes: [
      {
        path: "/priority",
        name: "گزارش کلی حق تقدم",
      },
      {
        path: "/disagree",
        name: "گزارش مخالفان تبدیل مطالبات",
      },
      {
        path: "/agree",
        name: "گزارش موافقان تبدیل مطالبات",
      },
      {
        path: "/buying",
        name: "گزارش پرداخت آنلاین",
      },
      {
        path: "/buyingfish",
        name: "گزارش آپلود فیش نقدی",
      },
      /*{
        path: "/bankpayments",
        name: "گزارش پرداخت بانکی",
      },*/
      {
        path: "/filemaking",
        name: "ساخت خودکار برگه",
      },
      {
        path: "/batchfile",
        name: "ساخت برگه از فایل",
      },
      {
        path: "/formbuilder",
        name: "ساخت دستی برگه",
      },
    ],
  },
  {
    path: "/messageBetter",
    icon: "MdMessage",
    name: "پیام ها",
  },
  {
    path: "/about",
    icon: "MdBusiness",
    name: "بروز رسانی اطلاعات شرکت",
  },
  {
    icon: "MdMiscellaneousServices",
    name: "سرویس ها",
    routes: [
      {
        path: "/shahkar/0/0",
        name: "استعلام شاهکار",
      },
      /*{
        path: "/auth/0/0",
        name: "احراز هویت (ثبت احوال)",
      },*/
      {
        path: "/sheba/0",
        name: "دریافت جزئیات شماره شبا",
      },
      {
        path: "/shebaMeli/0/0",
        name: "استعلام شبا با کد ملی",
      },
      {
        path: "/credit",
        name: "افزایش اعتبار سرویس ها",
      },
    ],
  },
  {
    icon: "MdSupportAgent",
    name: "تیکت های پشتیبانی",
    routes: [
      {
        path: "/ticket",
        name: "لیست تیکت ها",
      },
      {
        path: "/sending",
        name: "ارسال تیکت جدید",
      },
    ],
  },
  {
    path: "/contactUs",
    icon: "MdPhone",
    name: "تماس با ما",
  },
];

export default routes;
